import React from "react";

function PlusIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="21"
            fill="none"
            viewBox="0 0 22 21"
        >
            <path
                fill="#1693F0"
                d="M11 0C9.743 0 8.724.973 8.724 2.172v6.156H2.276C1.019 8.328 0 9.3 0 10.5c0 1.2 1.019 2.172 2.276 2.172h6.448v6.155C8.724 20.027 9.743 21 11 21s2.276-.973 2.276-2.172v-6.155h6.448C20.981 12.672 22 11.7 22 10.5c0-1.2-1.019-2.172-2.276-2.172h-6.448V2.173C13.276.972 12.257 0 11 0z"
            ></path>
        </svg>
    );
}

export default PlusIcon;
